module.exports = __webpack_public_path__ + "4c1e4c4e1042d6f6bde938d4193b14d1.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vbl.png
// module id = 1778
// module chunks = 2